module.exports = __webpack_public_path__ + "static/transposh6-19a014835a6d336192931e73959b38d9.jpg";